export function CalendarDateOutline({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 1.5V3.75M12 1.5V3.75M15.5625 13.2H2.4375M12 2.625C14.4975 2.76 15.75 3.7125 15.75 7.2375V11.8725C15.75 14.9625 15 16.5075 11.25 16.5075H6.75C3 16.5075 2.25 14.9625 2.25 11.8725V7.2375C2.25 3.7125 3.5025 2.7675 6 2.625H12Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 6.1875C8.0775 6.1875 7.2975 6.69 7.2975 7.665C7.2975 8.13 7.515 8.4825 7.845 8.7075C7.3875 8.9775 7.125 9.4125 7.125 9.9225C7.125 10.8525 7.8375 11.43 9 11.43C10.155 11.43 10.875 10.8525 10.875 9.9225C10.875 9.4125 10.6125 8.97 10.1475 8.7075C10.485 8.475 10.695 8.13 10.695 7.665C10.695 6.69 9.9225 6.1875 9 6.1875ZM9 8.3175C8.61 8.3175 8.325 8.085 8.325 7.7175C8.325 7.3425 8.61 7.125 9 7.125C9.39 7.125 9.675 7.3425 9.675 7.7175C9.675 8.085 9.39 8.3175 9 8.3175ZM9 10.5C8.505 10.5 8.145 10.2525 8.145 9.8025C8.145 9.3525 8.505 9.1125 9 9.1125C9.495 9.1125 9.855 9.36 9.855 9.8025C9.855 10.2525 9.495 10.5 9 10.5Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}
